import { Logger } from '../logger';
import { Store } from 'vuex';
import { AppState } from '@/store';
export interface BranchService {
  sendOrderSubmitSuccessEvent(): void;
  createAccountSuccessEvent(): void;
  viewMenuItemEvent(): void;
  loginUserEvent(): void;
}

export enum BranchEventCategory {
  Purchase = 'PURCHASE',
  ViewItem = 'VIEW_ITEM',
  RegisterUser = 'COMPLETE_REGISTRATION',
  Login = 'LOGIN',
}

export interface Branch {
  logEvent(eventType: string, eventAndCustomData?: object, contentItems?: object[], alias?: string, errorFunc?: (err: any) => void): void;
}

declare global {
  interface Window {
    branch?: Branch;
  }
}

export class AppBranchService implements BranchService {
  constructor(private store: Store<AppState>, private logger: Logger) {}

  private errorLogging(err: any, eventCategory: BranchEventCategory): void {
    this.logger.error(`Branch Event call error on [${eventCategory}]`, err);
  }
  private logEvent(eventCategory: BranchEventCategory) {
    try {
      const win = window as Window;
      win.branch?.logEvent(eventCategory, {}, [], '', (err: any) => {
        if (err !== null) {
          this.errorLogging(err, eventCategory);
        }
      });
    } catch (e: any) {
      this.errorLogging(e, eventCategory);
    }
  }

  sendOrderSubmitSuccessEvent(): void {
    this.logEvent(BranchEventCategory.Purchase);
  }

  createAccountSuccessEvent(): void {
    this.logEvent(BranchEventCategory.RegisterUser);
  }

  viewMenuItemEvent(): void {
    this.logEvent(BranchEventCategory.ViewItem);
  }

  loginUserEvent(): void {
    this.logEvent(BranchEventCategory.Login);
  }
}
